Handlebars.registerPartial('partials/common/create_global_guest_user/arrange_and_approve/list-user-row', Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return " checked";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<tr>\n    <td>\n        <div class=\"input-group\">\n            <input type=\"checkbox\" class=\"user-selection replay-safe\" data-user-id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"user_id") : depth0), depth0))
    + "\" value=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"user_id") : depth0), depth0))
    + "\"\n                id=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"type") : depth0), depth0))
    + "-"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"user_id") : depth0), depth0))
    + "\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"selected") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":52},"end":{"line":5,"column":83}}})) != null ? stack1 : "")
    + "> <label for=\""
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"type") : depth0), depth0))
    + "-"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"user_id") : depth0), depth0))
    + "\">\n            <div class=\"flex-parent space-between align-start user-info\">\n                <div class=\"label-text no-text-overflow user-name\" title=\""
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"first_name") : depth0), depth0)) != null ? stack1 : "")
    + " "
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"last_name") : depth0), depth0)) != null ? stack1 : "")
    + "\">\n                    "
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"first_name") : depth0), depth0)) != null ? stack1 : "")
    + " "
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"last_name") : depth0), depth0)) != null ? stack1 : "")
    + "\n                </div>\n            </div>\n            <div class=\"label-text no-text-overflow email\" title=\""
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"email") : depth0), depth0)) != null ? stack1 : "")
    + "\">"
    + ((stack1 = alias1((depth0 != null ? lookupProperty(depth0,"email") : depth0), depth0)) != null ? stack1 : "")
    + "</div>\n            </label>\n        </div>\n    </td>\n</tr>\n";
},"useData":true}));